import React, { useState, useContext, useEffect } from 'react';
import "./Schedules.css";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/picker/picker.css";
import "react-datepicker/dist/react-datepicker.css";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
// import KeyboardDatePicker from "react-KeyboardDatePicker";
import { createSchedule } from "../../../actions/schedule";
import { toast } from 'react-toastify';

import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

const CreateDays = (props) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [posDays, setPosDays] = useState([]);
    const [selDays, setSelDays] = useState([]);
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx)

    useEffect(() => {
        if (+startDate <= +endDate) {
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            let _st = new Date(startDate);
            _st.setHours(0, 0, 0, 0);
            let st = +startDate >= +now ? _st : now;
            let days = [];
            while (+st <= +endDate) {
                days.push(st.getDay());
                if (days.length === 7) break;
                else st.setDate(st.getDate() + 1);
            }
            setPosDays([...days]);
        }
    }, [startDate, endDate]);

    const handleDays = (event) => {
        let v = Number(event.target.value);
        let d = [...selDays];
        if (event.target.checked) {
            d.push(v);
        } else {
            d = d.filter(_d => _d !== v);
        }
        setSelDays([...d]);
    }

    const day_data = [
        { id: 0, name: l.sun },
        { id: 1, name: l.mon },
        { id: 2, name: l.tue },
        { id: 3, name: l.wed },
        { id: 4, name: l.thu },
        { id: 5, name: l.fri },
        { id: 6, name: l.sat }
    ]

    const handleSave = () => {
        let now = new Date();
        now.setHours(0, 0, 0, 0);
        let _st = new Date(startDate);
        _st.setHours(0, 0, 0, 0);
        let _ed = new Date(endDate);
        _ed.setHours(23, 59, 59, 99);
        if (_ed >= now) {
            if (selDays && selDays.length > 0) {
                let obj = {
                    from: _st < now ? now.valueOf() : _st.valueOf(),
                    to: _ed.valueOf(),
                    days: selDays,
                    clinicId: payload.clinicId,
                    subdomain: payload.subdomain
                }
                createSchedule(obj).then(res => {
                    if (res.status) {
                        props.loadSch()
                        toast.dismiss();
                        toast.success(l.slot_saved_successfully, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                    } else {
                        toast.dismiss();
                        toast.error(res.err, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                    }
                }).catch(err => {
                    console.log("err in create schedule ==== ", err.message, err.code, err)
                    let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.went_worng_pls_try_again;
                    toast.dismiss();
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                });
            } else {
                // Error
                toast.dismiss();
                toast.error(l.pls_sel_days, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }
        } else {
            // Error
            console.log("End Should be greater than or equal current date");
            toast.dismiss();
            toast.error(l.end_date_grt_equal, {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    return <div className="colBlock whiteBg bxSd">
        <div className="headingBox">
            <h2 className="headingTxt">{l.recc_sched}</h2>
        </div>
        {/* <div className="rowBlock">
            <div className="inputGroup flxCol">
                <div className="inputItem fullWidthAuto">
                    <span>{l.sched_from}</span>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            inputVariant="outlined"
                            className="pickerInput"
                            value={startDate}
                            onChange={(date) => setStartDate(date)}
                            animateYearScrolling
                            placeholdertext="From Date"
                            format="dd/MM/yyyy"
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div className="inputItem fullWidthAuto">
                    <span>{l.sched_to}</span>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            inputVariant="outlined"
                            className="pickerInput"
                            value={endDate}
                            onChange={(date) => setEndDate(date)}
                            animateYearScrolling
                            placeholdertext="To Date"
                            format="dd/MM/yyyy"
                        />
                    </MuiPickersUtilsProvider>
                </div>
            </div>
        </div> */}
        <div className='flexCol'>
            <div className='flexRow alignCntr pdngHSM'>
                <span className='minWidth'>{l.sched_from}</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        inputVariant="outlined"
                        className="pickerInput"
                        value={startDate}
                        disablePast={true}
                        onChange={(date) => setStartDate(date)}
                        animateYearScrolling
                        placeholdertext="From Date"
                        format="dd/MM/yyyy"
                    />
                </MuiPickersUtilsProvider>
            </div>
            <div className='flexRow alignCntr pdngHSM'>
                <span className='minWidth'>{l.sched_to}</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        inputVariant="outlined"
                        className="pickerInput"
                        value={endDate}
                        disablePast={true}
                        onChange={(date) => setEndDate(date)}
                        animateYearScrolling
                        placeholdertext="To Date"
                        format="dd/MM/yyyy"
                    />
                </MuiPickersUtilsProvider>
            </div>
        </div>
        <div className="headingBox">
            <h2 className="headingTxt">{l.sched_days}</h2>
        </div>
        <div className="hztlScrlBox">
            {day_data.map(day => <div className={`boxMd ripple ${posDays.indexOf(day.id) <= -1 ? "overLay avoidClick" : ""}`} key={day.id}>
                <label className="dayCheckbox">
                    <input type="hidden" name="days" value="False" />
                    <input className="dayCheckboxInput" name="days" value={day.id} type="checkbox" onChange={handleDays} checked={selDays.indexOf(day.id) > -1} />
                    <span className="dayCheckboxText">{day.name}</span>
                </label>
            </div>
            )}
        </div>

        <div className="btnGroup flxEnd pd012">
            <button className={`btnFilled md ripple ${selDays && selDays.length > 0 ? "" : "avoidClick overLay"}`} onClick={handleSave}>
                <span>{l.save} &amp; {l.next}</span>
            </button>
        </div>
    </div>

}

export default CreateDays;